import { formatISO } from 'date-fns';

export interface NavLink {
  icon?: React.FC<{ className?: string }>;
  title: string;
  path: string;
  permission: boolean;
  id?: string;
  search?: string;
  hasUnsavedChanges?: boolean;
  // called when we switch from the tab to another tab
  deactivateHandler?: () => unknown;
  // called when we switch to the tab from another tab
  activateHandler?: () => unknown;
  openedFromId?: string;
}

export enum TabType {
  Dashboard = 'dashboard',
  Calendar = 'calendar',
  Patient = 'patient',
  Settings = 'settings',
}
export function updateTodayInCalendarUrl(
  search: string,
  updateCurrentDay = false,
) {
  if (search.startsWith('?')) search = search.substring(1);

  const searchParams = new URLSearchParams(search);
  searchParams.set('today', formatISO(new Date(), { representation: 'date' }));
  if (updateCurrentDay) {
    searchParams.set(
      'currentDay',
      formatISO(new Date(), { representation: 'date' }),
    );
  }
  search = '?' + searchParams.toString();
  return search;
}
